<template>
  <div class="ah-product-card-body">
    <div class="ah-product-card-category">
      {{ category }}
    </div>
    <div class="ah-product-card-heading">
      {{ heading }}
    </div>
    <div class="ah-product-card-excerpt" v-html="excerpt">
      
    </div>
  </div>
</template>

<script>

  export default {
    name: 'card-body',
    props: {
      category: {
        type: String,
        default: 'Default Category',
      },
      heading: {
        type: String,
        default: 'Card Heading',
      },
      excerpt: {
        type: String,
        default: 'Lorem ipsum dolor sit amet.',
      },
    },
  }
</script>

<style lang="scss">
  @import "../../../scss/_variablesAH.scss";
  .ah-product-card-body {
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
  }
  .ah-product-card-category {
    color: #555;
    margin-bottom: 7.5px;
    font-family: $font-main;
    font-size: 15px;
  }
  .ah-product-card-heading {
    color: $blue-a;
    margin-bottom: 8px;
    font-family: $font-main;
    font-size: 20px;
    font-weight: 600;
  }
  .ah-product-card-excerpt {
    color: $blue-a;
    font-family: $font-main;
    font-size: 16px;
  }
</style>
